import axios from '@/util/axios'
import { API_RELAY_PATH } from '@/util/constants'
import store from '@/store'

/**
 * ダッシュボード書式DL一覧
 * @param  {} params={}
 */
export const listFormDownloads = (params = {}) => {
  const defaults = {
    _path: 'DA/002',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}
